<template>
  <el-container>
    <main class="page__container">
      <div class="container">
        <h2>Live Stream сервера</h2>
        <search :query.sync="query" @search="search" />
        <el-table ref="table" :data="items">
          <el-table-column label="Название сервера">
            <template slot-scope="scope">
              <router-link class="link" :to="{ name: 'servers:edit', params: { id: scope.row.id } }">
                {{ scope.row.name }}
              </router-link>
            </template>
          </el-table-column>
          <el-table-column label="Платформа" width="110" align="center">
            <template slot-scope="scope">
              <span :class="platformClass(scope.row.id_media_core)">
                {{ platformName(scope.row.id_media_core) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="Количество камер / Занято / Свободно" align="center">
            <template slot-scope="scope">
              {{ scope.row.cameras_count }} / {{ scope.row.current_cameras_count }} /
              {{ scope.row.freely_cameras_count }}
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="Дата создания" />
          <el-table-column prop="status" label="Статус API" width="120" align="center">
            <template slot-scope="scope">
              <i v-if="scope.row.status === 0" class="el-icon-error" />
              <i v-if="scope.row.status === 1" class="el-icon-success" />
            </template>
          </el-table-column>
          <el-table-column prop="server_version" label="Версия ПО" width="110" />
        </el-table>
        <el-pagination
          class="list__pagination"
          layout="prev, pager, next"
          :page-size="count"
          :total="total"
          :current-page="page"
          @current-change="changePage"
        />
      </div>
    </main>
    <el-footer class="page__active_bar">
      <el-button
        v-if="$can('create', 'proxy_servers')"
        class="page__active_button"
        icon="el-icon-plus"
        type="primary"
        @click="$router.push({ name: 'servers:create' })"
      >
        Добавить
      </el-button>
    </el-footer>
  </el-container>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import routeList from "@/core/mixins/routeList";
import Search from "@/components/Search";
import { MEDIA_CORE_NAME, MEDIA_CORE_CLASS } from "@/core/helpers/const";

export default {
  name: "Servers",
  components: {
    Search,
  },
  mixins: [routeList],
  data() {
    return {
      query: "",
    };
  },
  computed: {
    ...mapState("servers", {
      items: (state) => state.servers.data,
      total: (state) => state.servers.total,
      count: (state) => state.servers.count,
    }),
    ...mapGetters("servers", ["getQuery"]),
  },
  methods: {
    ...mapActions("servers", {
      getList: "GET_SERVERS",
    }),
    ...mapMutations("servers", {
      setQuery: "SET_QUERY",
    }),
    platformName(idMediaCore) {
      return MEDIA_CORE_NAME[idMediaCore] || "—";
    },
    platformClass(idMediaCore) {
      return MEDIA_CORE_CLASS[idMediaCore] || "";
    },
  },
};
</script>

<style></style>
